/** @format */
import {CreateAiReportFeedbackInput} from 'graphql/generated/types';

import {FormValues} from '../types';
import {DISLIKES_OPTIONS, HYPOTHESIS_OPTIONS} from '../constants';

const mapFormValues = (
  data: FormValues,
  aiReportId: string | null,
  companyUuid: string
): CreateAiReportFeedbackInput => {
  const hypothesis =
    HYPOTHESIS_OPTIONS.find(option => option.value === data.hypothesis)?.label || '';

  const dislikes = data.dislikes.reduce<string[]>((acc, cur) => {
    const dislikeLabel = DISLIKES_OPTIONS.find(option => option.value === cur)?.label || '';
    return [...acc, dislikeLabel];
  }, []);

  return {
    aiReportId: aiReportId || '',
    companyUuid,
    rating: String(data.rating ?? 0),
    hasUsefulHypotheses: hypothesis,
    ...(dislikes.length ? {dislikes: JSON.stringify(dislikes)} : {}),
    ...(data.comment ? {comment: data.comment} : {}),
    ...(data.bugDescription ? {errorDescription: data.bugDescription} : {}),
    ...(data.screenshots.length ? {screenshots: JSON.stringify(data.screenshots)} : {}),
  };
};

export {mapFormValues};
